// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"DeliveryBanner_modalHeader__wjLmy"};